<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-nat-gateway`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.38 3a4 4 0 012.832 1.175l7.62 7.64A4 4 0 0142 14.64V43a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2h22.38zm-1.19 4H10v34h28V15.83a2 2 0 00-.584-1.412l-6.81-6.83A2 2 0 0029.19 7zM34 25.9a1 1 0 011 1v2a1 1 0 01-1 1l-11-.001V32.8a1 1 0 01-1.591.807l-5.816-4.266.007-.01-2.178-1.631a1 1 0 01.599-1.8H34zm-7.408-10.706A1 1 0 0025 16l-.001 2.899H14a1 1 0 00-1 1v2a1 1 0 001 1h20.002a1 1 0 00.593-1.805l-2.603-1.919.006-.012-5.406-3.97z"/></svg>
</template>
<script>

export default {
  name: 'IconNatGateway',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
